<template>
  <div id="hfq-content" v-cloak class="hfq-content weicai-home">
    <!-- 官网增加防诈骗声明弹窗 -->
    <!-- <div v-if="showAntifraudPop" class="antifraud-pop">
      <div class="fraud-tips">
        <img class="fraud-tips-close" src="https://www.haohuan.com/datahub/gfs/2022-09/7d6599a1324d6800cb6491e4216083a2-8.png" @click="handleClose">
        <div v-html="fraudPopInfo"></div>
      </div>
    </div> -->
    <Header></Header>
    <div class="section section-1">
      <div class="scale-img">
        <img src="@/assets/images/weicai/home/main.jpg" alt="" />
      </div>
    </div>
    <div id="section-2" class="section section-2">
      <div class="section-2-content">
        <div class="section-2-tips" @click="goNoticeLink">
          <img src="https://datahub.haohuan.com/gfs/2025-03/d3b06946499aef9766a7af3ab13932d5-8.png">
          <a class="tips-notice" target="_blank" href="https://api-m.haohuan.com/api/staticProtocol/getContentById?code=weicai_shengming">北京微财科技有限公司的严正声明</a>
          <img class="left-link" src="https://datahub.haohuan.com/gfs/2025-03/e3a5540fa46592a17d6deb64ee9f99f2-8.png">
        </div>
        <h3>关于微财</h3>
        <div class="section-2-detail">
          <p>
            微财数科是一家创新型金融科技企业，以“科技为本，创新金融服务，创造美好生活”为使命，凭借长期积累的金融科技能力和智能风控技术，致力于成为金融机构值得信赖的合作伙伴；同时通过科技力量助力消费金融业务，服务高成长用户，赋能小微经济发展。
          </p>
        </div>
        <ul>
          <li v-for="item in aboutWe" :key="item.text1">
            <div class="img">
              <img :src="item.icon" alt="微财" />
            </div>
            <h4>{{ item.text1 }}</h4>
            <p>{{ item.text2 }}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- we产品 -->
    <!-- <div class="section product">
      <div class="product-content">
        <div class="img">
        <img src="@/assets/images/weicai/home/product.jpg" alt="">
      </div>
      <div class="content">
        <h4>We产品</h4>
        <p class="title">护航年轻人生活 助力年轻人成长</p>
        <p class="desc">好分期是微财数科旗下专业的信贷综合信息和技术服务平台，上线以来一直保持快速增长。凭借强大的技术实力，出色的风控能力以及专业人才储备和创新能力，通过与持牌金融机构合作，为用户带来方便、快捷、安全的信贷综合信息及技术服务。</p>
        <div class="btn" @click="goHaofenqi">立即体验</div>
      </div>
      </div>
    </div> -->
    <NewsList id="section-3" class="section section-3" />
    <Footer></Footer>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
import Header from '@/components/header'
import Footer from '@/components/footer'
import NewsList from '../../components/newsList.vue'
import { keywordsList, descriptionList } from '../../../config'
import {  getCMSGuideInfo } from "@/api/home";


export default {
  components: {
    Header,
    Footer,
    NewsList
  },
  data () {
    return {
      aboutWe: [
        {
          icon: require('@/assets/images/weicai/home/about-we-1.png'),
          text1: '合规运营',
          text2: '合作众多持牌金融机构'
        },
        {
          icon: require('@/assets/images/weicai/home/about-we-2.png'),
          text1: '安全保障',
          text2: '获金融科技安全产品认证'
        },
        {
          icon: require('@/assets/images/weicai/home/about-we-3.png'),
          text1: '智能风控',
          text2: '全流程自动化纯自研'
        }
      ],
      reportList: [],
      newsTotalList: [],
      homeList: [],
      totalPage: 6,
      count: 1,
      isShow: true,
      bannerList: [],
      showAntifraudPop: false,
      fraudPopInfo: ''
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    // document.title = titles.home;
    // if(!common.isMetaName('keywords')){
    //   this.createMeta()
    // }
    // 获取缓存 上次弹窗的时间戳
    // const lastPopTime = localStorage.getItem("lastPopTimeStamp");
    // console.log('lastPopTime',lastPopTime);
    // if (!lastPopTime) {
    //   this.getPreventFraudGuideInfo();
    // } else {
    //   // 1209600000 = 24 * 60 * 60 * 1000 * 14
    //   (+new Date() - lastPopTime > 1209600000) && this.getPreventFraudGuideInfo();
    // }
  },
  methods: {
    createMeta () {
      let head = document.getElementsByTagName('head')
      let keywordsMeta = document.createElement('meta')
      let descriptionMeta = document.createElement('meta')
      keywordsMeta.name = 'keywords'
      keywordsMeta.content = keywordsList[0]
      descriptionMeta.name = 'description'
      descriptionMeta.content = descriptionList[0]
      head[0].appendChild(keywordsMeta)
      head[0].appendChild(descriptionMeta)
    },
    goHaofenqi () {
      window.open('https://www.haofenqi.cn/', 'newW')
    },
    goNoticeLink() {
      window.open('https://api-m.haohuan.com/api/staticProtocol/getContentById?code=weicai_shengming', 'newW')
    },
    // handleClose() {
    //   this.showAntifraudPop = false;
    //   // 存储当前关闭的时间戳
    //   localStorage.setItem("lastPopTimeStamp", +new Date());
    // },
    // 获取CMS静态协议配置的防诈骗指南信息
    // getPreventFraudGuideInfo: function() {
    //   getCMSGuideInfo().then((res) => {
    //     console.log(res);
    //     this.showAntifraudPop = true
    //     this.fraudPopInfo = res;
    //   })
    // },
  }
}
</script>

<style lang="less" scoped>
@import "~@/style/weicai.less";
@import "./home.less";

.antifraud-pop {
  position: fixed;
  z-index: 12;
  width: 100%;
  min-height: 100vh;
  background: rgba(0,0,0,0.6);
  .fraud-tips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 30px;
    width: 660px;
    background: #FFFFFF;
    border-radius: 10px;
    &-close {
      position: absolute;
      width: 14px;
      height: 14px;
      top: 15px;
      right: 15px;
    }
    /deep/ #protocol-container {
      padding: 0;
    }
    /deep/ h3 {
      text-align: center;
      height: 24px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #2E2E33;
      line-height: 24px;
      margin-bottom: 16px;
    }
    /deep/ p {
      font-size: 12px;
      font-family: DINPro-Regular, PingFangSC-Regular, PingFang SC;
      color: #2E2E33;
      line-height: 24px;
      text-indent: 2em;
      img {
        width: 50px;
        height: 14px;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue